module.exports = __webpack_public_path__ + "static/media/MasaiSunset.ef5715b4.jpg";